<template>
    <div>
        <v-btn v-if="buttonFlagBoolean"
                :dark="true"
               color="normal"
               x-small
               @click.stop="flagChange"
        >Y
        </v-btn>
        <v-btn v-else 
                :dark="false"
               color="normal"
               x-small
               @click.stop="flagChange"
        >N
        </v-btn>
        <!--요청시 나오는 로딩 입니다.-->
        <div class="loading_wrap" v-show="isLoading">
            <div class="loading"></div>
            <div class="loading"></div>
            <div class="loading"></div>
        </div>
    </div>
</template>

<script>
import {PATH} from "@/constants";

/**
 * flag 변경에 대한 부분을 컨트롤 하는 컴포넌트입니다.
 * deleteYn, useYn, removeYn 의 값을 컨트롤 하며
 * 현제는 장치 상세정보, 장치 정보에서 사용하고 있습니다
 * refresh-data-load 로 함수를 넣어주면 요청시 emit으로 던져줍니다.
 *
 */
export default {
    name: "YNButtonFlag",
    data() {
        return {
            isLoading: false
        }
    },
    props: {
        whatTypeName:{//프린트인지 장치인지 알려줍니다.
            type: String,
            default: undefined
        },
        buttonFlag: { //flag의 Y or N 의 값을 알려줍니다.
            type: String,
            default: undefined
        },

        serial:{ //프린터 or 장치 의 serial 을 알려줍니다.
            type: Number,
            default: undefined
        },
        idKeyName:{//monitoringPrinterId 인지 tnDeviceId 인지 알려줍니다
            type: String,
            default: undefined
        },
        flagKeyName:{//deleteYn,useYn,removeYn 3중 어떤건지 알려줍니다.
            type: String,
            default: undefined
        }
    },
    computed: {
        /**
         * 위에 버튼을 컨트롤 하기위해 동작합니다.
         * @returns {boolean}
         */
        buttonFlagBoolean() {
            return this.buttonFlag ==='Y'
        }
    },
    methods: {
        /**
         * 알맞는 body값을 만들어서 프린트 or 장치 flag를 컨트롤합니다.
         */
        flagChange() {
            if(!this.serial || !this.buttonFlag) {
                alert("요청에 필요한 데이터가 없습니다. 다시 확인해주세요")
                return
            }
            const body = {
                [this.idKeyName]:this.serial, //serial번호
                [this.flagKeyName]:this.buttonFlag ==='Y'?'N':'Y'//Y , N 바꾸기
            }
            this.updateRq(body, this.whatTypeName)

        },
        /**
         * flag 버튼 클릭시 동작하는 요청 함수입니다.
         * 클릭하면 해당 flag를 변경시켜줍니다.
         * @param body
         * @param name
         * @returns {Promise<void>}
         */
        async updateRq(body, name) {
            this.isLoading = true;
            const url = name === 'printer' ? PATH.MONITORING.PRINTER_UPDATE : PATH.MONITORING.DEVICE_UPDATE
            const res = await this.$request(url)
                .setObject({
                    ...body
                })
                .catch((e) => {
                    this.isLoading = false;
                    alert('flag 컨트롤 실패')
                })
                .enqueue()
            if(res ===1) alert("flag값이 변경 되었습니다..")
            this.isLoading = false;
            //refresh할 테이블 요청데이터 넘길때부터 다시 요청할 함수를 넣음
            this.$emit("refresh-data-load")
        }
    },
}
</script>

<style scoped>

.loading_wrap {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
    background: rgba(0, 0, 0, 0.5);
}

.loading {
    width: 8px;
    height: 8px;
    background: #aaaaaa;
    border-radius: 50%;
    animation: loading-cricle 1.5s infinite ease-in-out;
    display: inline-block;
    margin-right: 8px;
}

.loading:nth-child(2) {
    animation-delay: .5s;
}

.loading:nth-child(3) {
    animation-delay: 1s;
}

@keyframes loading-cricle {
    0% {
        opacity: .4;
        transform: scale(1, 1);
    }
    50% {
        opacity: 1;
        transform: scale(1.2, 1.2);
    }
    100% {
        opacity: .4;
        transform: scale(1, 1);
    }
}

/*Search Box 부분 font 랑 사이즈 조정 부분입니다*/
>>> .v-input__control .v-input__slot .v-text-field__slot input {
    font-size: 11px;
    padding: 0;
}

>>> .v-input__control .v-input__slot fieldset {
    height: 47px;
}
</style>